import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["file", "preview", "container"]

  connect() {
    this.previewTarget.hidden = true
  }

  async process(event) {
    event.preventDefault()
    const file = this.fileTarget.files[0]
    if (!file) return

    const content = await file.text()
    const items = this.parseFileContent(content)
    
    // Add items to the list using the list-items controller
    const listItemsController = this.application.getControllerForElementAndIdentifier(
      this.containerTarget,
      'list-items'
    )

    items.forEach(item => {
      listItemsController.add(event)
      const newRow = this.containerTarget.querySelector('.nested-fields:first-child')
      
      // Fill in the values
      newRow.querySelector('input[name*="[name]"]').value = item.name
      newRow.querySelector('input[name*="[weight]"]').value = item.weight
      
      // Set the tags if any
      if (item.tags.length > 0) {
        const tagSelect = newRow.querySelector('[data-controller="tags"]')
        const tagsController = this.application.getControllerForElementAndIdentifier(tagSelect, 'tags')
        if (tagsController && tagsController.tomSelect) {
          tagsController.tomSelect.setValue(item.tags)
        }
      }
    })

    // Clear the file input
    this.fileTarget.value = ''
  }

  parseFileContent(content) {
    const items = []
    const delimiter = this.detectDelimiter(content)
    
    content.split('\n').forEach(line => {
      line = line.trim()
      if (!line) return

      const values = line.split(delimiter).map(v => v.trim())
      if (values[0]) {
        items.push({
          name: values[0],
          weight: parseInt(values[1]) || 1,
          tags: values.slice(2).filter(t => t)
        })
      }
    })

    return items
  }

  detectDelimiter(content) {
    const firstLine = content.split('\n')[0]
    const delimiters = {
      csv: ',',
      tab: '\t',
      semicolon: ';'
    }
    
    const counts = Object.values(delimiters)
      .map(d => ({ delimiter: d, count: firstLine.split(d).length - 1 }))
    
    const mostCommon = counts.reduce((max, curr) => 
      curr.count > max.count ? curr : max
    , { delimiter: ',', count: 0 })

    return mostCommon.delimiter
  }
} 